import React, { useMemo, useState } from "react"
import { Form } from "antd"

import api from "@api"
import { CreateModal } from "@components/Page"
import { useAppContext } from "@components/AppContext"

import getInputs from "./helpers/getInputs"
import getExtendedBankAccounts from "./helpers/getExtendedBankAccounts"

const LABEL_ENTITY = "Bank Account"
const LABEL_ADD = `Connect ${LABEL_ENTITY}`

const createOperation = api.get("transactions/CreateBankAccount")

const LABEL_CONNECT = "Connect"


const BankAccountCreateModal = ({ modal, table }) => {
  const [ form ] = Form.useForm()
  const [ bankAccounts, setBankAccounts ] = useState()

  const { identity, authorizeIdentity } = useAppContext()
  const { customers } = identity

  const createInputs = useMemo(() =>
    getInputs(form, bankAccounts)
  , [ bankAccounts ])

  const schema = createOperation.getSchema(createInputs)

  const onSuccess = () =>
    authorizeIdentity()

  modal.current.openWithBankAccounts = currentBankAccounts => {
    const extendedBankAccounts = getExtendedBankAccounts(customers, currentBankAccounts)
    setBankAccounts(extendedBankAccounts)
    modal.current.open()
  }

  const createModalProps = {
    title: LABEL_ADD,
    entity: LABEL_ENTITY,
    operation: createOperation.id,
    submitLabel: LABEL_CONNECT,
    form,
    modal,
    table,
    schema,
    onSuccess,
  }

  return (
    <CreateModal {...createModalProps} />
  )
}

export default BankAccountCreateModal
